import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_DELETE,
  payload,
});

export const init_local_workspace_delete = (state: STATE__workspace, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    if (state.workspace_current._id == id) {
      state.workspace_current = DTO__workspace.CREATE_STUB();
    }

    state.workspaces_map.delete(id);
  }

  //refresh map to trigger re-render
  state.workspaces_map = new Map(state.workspaces_map);
};
